import React from 'react';
import { MenuItem } from '@mui/material';
import { AwardingRuleParameterType, getAwardingRuleParameterTypeLabel } from '../../../../Enums';
import { useTranslation } from 'react-i18next';
import StyledSelect from '../StyledSelect';
import InputTitle from '../InputTitle';
import CustomFieldParameter from './CustomFieldParameter';
import DataviewParameter from './DataviewParameter';
import HyperfindParameter from './HyperfindParameter';
import BySubmittedRequestDateTimeParameter from './BySubmittedRequestDateTimeParameter';
import './Step2-SortingRuleSection.scss';

const noop = () => { };


/**
 * @param {{
 *  currentAwardingRule: ApiAdmin.IBodyAwardingRules,
 *  handleSourceSelected: Function,
 *  handleCustomDataFieldInfosChange: Function,
 *  handleHyperfindBelongingInfosChange: Function,
 *  handleDataviewInfosChange: Function,
 *  isDisabled: boolean,
 *  fieldValidationErrors: {[Key: string] : boolean},
 * }} props
 */
function SortingRuleEdit(props) {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'settings.ruleSet.sortingRuleStep' });
    const {
        currentAwardingRule,
        handleSourceSelected = noop,
        handleCustomDataFieldInfosChange = noop,
        handleHyperfindBelongingInfosChange = noop,
        handleDataviewInfosChange = noop,
        isDisabled,
        fieldValidationErrors,
    } = props;
    const { index, type } = currentAwardingRule;

    const AwardingRuleParameterTypeOptions = Object.values(AwardingRuleParameterType).map((v) => ({
        value: v,
        label: getAwardingRuleParameterTypeLabel(v),
    }));

    const selectedType = AwardingRuleParameterTypeOptions.find((x) => x.value === type);

    return (
        <>
            <div className="rse--selection-field-container srs-fullWidth-container">
                <InputTitle>{t('source')}</InputTitle>
                <StyledSelect
                    labelId="select-custom-field-label"
                    id="select-custom-field-type"
                    disabled={isDisabled}
                    renderValue={(/** @type {string} */
                        _value,
                    ) => selectedType?.label}
                    value={type !== -1 ? type : ''}
                    onChange={(/** @type {React.ChangeEvent<{ name?: string; value: string }>} */
                        event,
                    ) => handleSourceSelected(index, event.target.value)}
                    style={{ marginBottom: '20px' }}
                >
                    {AwardingRuleParameterTypeOptions.map((x) => (
                        <MenuItem
                            value={x.value}
                            key={`SelectItem_${x.label}`}
                        >
                            {x.label}
                        </MenuItem>
                    ))}
                </StyledSelect>
                {!!fieldValidationErrors.type && <span style={{ color: 'red' }}>{t('selectSource')}</span>}
            </div>
            <>
                {type === AwardingRuleParameterType.DataviewData && (
                    <DataviewParameter
                        currentAwardingRule={currentAwardingRule}
                        onChange={handleDataviewInfosChange}
                        fieldValidationErrors={fieldValidationErrors}
                        isDisabled={isDisabled}
                    />)}
                {type === AwardingRuleParameterType.CustomDataType && (
                    <CustomFieldParameter
                        currentAwardingRule={currentAwardingRule}
                        onChange={handleCustomDataFieldInfosChange}
                        fieldValidationErrors={fieldValidationErrors}
                        isDisabled={isDisabled}
                    />)}
                {type === AwardingRuleParameterType.HyperfindBelonging && (
                    <HyperfindParameter
                        currentAwardingRule={currentAwardingRule}
                        onChange={handleHyperfindBelongingInfosChange}
                        fieldValidationErrors={fieldValidationErrors}
                        isDisabled={isDisabled}
                    />)}
                {type === AwardingRuleParameterType.BySubmittedRequestDateTime && (
                    <BySubmittedRequestDateTimeParameter
                        currentAwardingRule={currentAwardingRule}
                        fieldValidationErrors={fieldValidationErrors}
                        isDisabled={true}// Always "Ascending"
                    />)}
            </>
        </>
    );
}

export default SortingRuleEdit;
